import React, { useRef, useState } from "react";
import competencesData from "./populateCompetences";

import { FiLink2 } from "react-icons/fi";
import { Competence, CompetenceUrl, SubCompetence } from "../../shared/types";
import { NavLink, useParams } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";

type Props = {
  subCompetence: SubCompetence;
  setSubCompetence: (value: SubCompetence) => void;
  competence: Competence;
  setCompetence: (value: Competence) => void;
};

const SubCompetencesPage = ({
  subCompetence,
  setCompetence,
  competence,
}: Props) => {
  const [selectedCompetence, setSelectedCompetence] = useState<number | null>(
    null
  );
  const [selectedItem, setSelectedItem] = useState<number | null>(null);

  const [selectedItemItem, setSelectedItemItem] = useState<number | null>(null);
  const [selectedItemUrlClick, setSelectedItemUrlClick] = useState<
    number | null
  >(null);

  const handleCompetenceClick = (competenceId: number) => {
    setSelectedCompetence(
      competenceId === selectedCompetence ? null : competenceId
    );

    window.scrollTo(0, 0);

    setSelectedItemItem(null);
    setSelectedItem(null); // Reset selected item when clicking on a new competence
    setSelectedItemUrlClick(null);
  };

  const renderUrlComponent = (urls: CompetenceUrl[]) => {
    const bracketOpen = "(";
    const bracketClosed = ")";
    const comma = ", ";

    return (
      <div>
        <p>
          {bracketOpen}

          {urls.map((item, index) => (
            <a href={item.url} target="_new">
              <span className="text-palette3">{item.name}</span>

              {urls.indexOf(item) !== urls.length - 1 && comma}
            </a>
          ))}
          {bracketClosed}
        </p>
      </div>
    );
  };

 

  return (
    <div className="bg-gray-100 w-full h-full sm:h-full pb-8 2xl:h-full 2xl:py-40 flex flex-col justify-center items-center lg:px-0 px-4">
      <div className="container mx-auto text-center mb-8">
        <NavLink
          to={`/competences/`}
          onClick={() => setCompetence(competence)}
        >
          <div className="flex items-center lg:justify-start justify-center mt-24 mb-6 ">
            <IoMdArrowBack className="text-palette3" />
            <h1 className="text-xl 2xl:text-2xl text-palette3 text-start px-4 ">
              Back to Competences Page
            </h1>
          </div>
        </NavLink>
        <h1 className="2xl:text-7xl  lg:text-6xl   font-bold text-4xl text-center  text-palette1 mb-6 lg:mb-6">
          {(subCompetence?.title ?? "")}{" "}
        </h1>
        <p className="text-gray-950 2xl:text-4xl lg:text-xl ">
          {subCompetence.shortDescription !==
            "Click here for more details about methods and tools" &&
            subCompetence.longDescription}
        </p>
      </div>
      <div className="container text-center lg:text-start px-16">
        <div className="grid grid-cols-1 mt-4 gap-4">
          {subCompetence.items.map((item) => (
            <div
              key={item.id}
              className={`bg-white p-4 gap-8 flex flex-col justify-start  rounded-md shadow  ${
                item.image === "" ? "col-span-full text-center" : ""
              }`}
            >
              <div className="flex w-full lg:flex-row flex-col lg:gap-8 gap-4 ">
                {item.image !== "" && (
                  <img
                    src={item.image}
                    alt={`Item ${item.id} Image`}
                    className="lg:w-1/2 w-full h-64 object-contain  shadow-palette3 rounded-md shadow-md"
                  />
                )}
                <div
                  className={`flex lg:w-1/2 w-full flex-col ${
                    item.image === "" ? "text-center lg:w-full" : ""
                  }`}
                >
                  <h3 className="text-lg font-bold ">{item.title}</h3>
                  <p className="">{item.longDescription}</p>
                  {item.items.length > 0 && (
                    <div className="grid sm:grid-cols-2 grid-cols-1 lg:grid-cols-3 2xl:grid-cols-4 mt-4 gap-4">
                      {item.items.map((i, index) => (
                        <div className={`flex w-full flex-col`}>
                          <h3 className="text-lg  ">{i.title}</h3>
                          <p className="">{i.longDescription}</p>

                          {(i.urls?.length ?? 0) > 0 &&
                            renderUrlComponent(i.urls ?? [])}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SubCompetencesPage;
